import { render, staticRenderFns } from "./yst.vue?vue&type=template&id=3c87bdbd&scoped=true&"
import script from "./yst.vue?vue&type=script&lang=js&"
export * from "./yst.vue?vue&type=script&lang=js&"
import style0 from "./yst.vue?vue&type=style&index=0&id=3c87bdbd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c87bdbd",
  null
  
)

export default component.exports